module.exports = __webpack_public_path__ + "static/work-1-5a225ff463187ba99dea3f275e85e67d.png";